// HTTP Actions
export const APIVERSION = 'v1';
